import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {ToastService} from '../../services/toast.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-add-device',
  templateUrl: './add-device.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./add-device.component.scss']
})
export class AddDeviceComponent implements OnInit, OnChanges {
  @Input() addDevice: any;
  @Input() enableAddDevice: string;
  @Output() hideModal = new EventEmitter<boolean>();
  colors = this.commonService.colors;

  constructor(
    private toastService: ToastService,
    private commonService: CommonService
  ) {
  }

  ngOnInit(): void {
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.enableAddDevice = 'addDevice';
  }

  addDevices() {
    if (this.addDevice) {
      this.addDevice = false;
      this.enableAddDevice = '';
      this.hideModal.emit(true);
    } else {
      this.addDevice = true;
      this.enableAddDevice = 'addDevice';
    }
  }

  addNewDevice() {
    this.toastService.showSuccess('Device Added Successfully', true);
    this.addDevices();
  }
}
